/**
 * Provinces API service
 */

import { httpClient } from '@/utils/httpClient';
import type { APIProvince, DRFPaginatedResponse } from '@/types';

export interface ProvinceListParams {
    page?: number;
    page_size?: number;
}

const buildQuery = (params: ProvinceListParams): string => {
    const usp = new URLSearchParams();
    if (params.page !== undefined) usp.append('page', String(params.page));
    if (params.page_size !== undefined) usp.append('page_size', String(params.page_size));
    const s = usp.toString();
    return s ? `?${s}` : '';
};

export const provincesService = {
    async list(params?: ProvinceListParams): Promise<DRFPaginatedResponse<APIProvince>> {
        const qs = buildQuery(params ?? {});
        return httpClient.get<DRFPaginatedResponse<APIProvince>>(`/provinces/${qs}`);
    },
};

export default provincesService;
